import SVGFrame from "../../assets/images"
import TireCard from "../tire-card"
import React, { Component } from "react";
import ListCountry from '../../assets/images/country';
import Slider from "react-slick";
import './styles.scss'
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            style={{ ...style, display: "none", }}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            style={{ ...style, display: "none", background: "green" }}
        />
    );
}
export default class TireCardSlider extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }

    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            // adaptiveHeight: true
        };
        const listTire = [
            {
                name: 'Tier 1',
                mintedRatio: '0.08',

                box: SVGFrame.box1,
                countryOfTier: [
                    { img: ListCountry.England, name: 'England', minted: 4 },
                    { img: ListCountry.France, name: 'France', minted: 4 },
                    { img: ListCountry.Brazil, name: 'Brazil', minted: 4 },
                    { img: ListCountry.Spain, name: 'Spain', minted: 4 },

                ],




            },
            {
                name: 'Tier 2',
                mintedRatio: '0.08',

                box: SVGFrame.box2,
                countryOfTier: [

                    { img: ListCountry.Germany, name: 'Germany', minted: 4 },
                    { img: ListCountry.Argentina, name: 'Argentina', minted: 4 },
                    { img: ListCountry.Belgium, name: 'Belgium', minted: 4 },
                    { img: ListCountry.Portugal, name: 'Portugal', minted: 4 },

                ],
            },
            {
                name: 'Tier 3',
                mintedRatio: '0.08',

                box: SVGFrame.box3,
                countryOfTier: [
                    { img: ListCountry.Netherlands, name: 'Netherlands', minted: 4 },
                    { img: ListCountry.Denmark, name: 'Denmark', minted: 4 },
                    { img: ListCountry.Croatia, name: 'Croatia', minted: 4 },
                    { img: ListCountry.Uruguay, name: 'Uruguay', minted: 4 },


                ],
            },
            {
                name: 'Tier 4',
                mintedRatio: '0.08',

                box: SVGFrame.box4,
                countryOfTier: [
                    { img: ListCountry.Poland, name: 'Poland', minted: 8 },
                    { img: ListCountry.Senegal, name: 'Senegal', minted: 8 },
                    { img: ListCountry.USA, name: 'USA', minted: 8 },
                    { img: ListCountry.Serbia, name: 'Serbia', minted: 8 },

                ],
            },
            {
                name: 'Tier 5',
                mintedRatio: '0.08',

                box: SVGFrame.box5,

                countryOfTier: [
                    { img: ListCountry.Switzerland, name: 'Switzerland', minted: 12 },
                    { img: ListCountry.MExico, name: 'Mexico', minted: 12 },
                    { img: ListCountry.Wales, name: 'Wales', minted: 12 },
                    { img: ListCountry.Ghana, name: 'Ghana', minted: 12 },

                ],
            },
            {
                name: 'Tier 6',
                mintedRatio: '0.08',

                box: SVGFrame.box6,
                countryOfTier: [
                    { img: ListCountry.Ecuador, name: 'Ecuador', minted: 20 },
                    { img: ListCountry.Morocco, name: 'Morocco', minted: 20 },
                    { img: ListCountry.Cameroon, name: 'Cameroon', minted: 20 },
                    { img: ListCountry.Canada, name: 'Canada', minted: 20 },

                ],
            },
            {
                name: 'Tier 7',
                mintedRatio: '0.08',
                box: SVGFrame.box7,
                countryOfTier: [
                    { img: ListCountry.Japan, name: 'Japan', minted: 11 },
                    { img: ListCountry.Qatar, name: 'Qatar', minted: 11 },
                    { img: ListCountry.Tunisia, name: 'Tunisia', minted: 11 },
                    { img: ListCountry.SouthKorea, name: 'South Korea', minted: 11 },
                ],

            },
            {
                name: 'Tier 8',
                mintedRatio: '0.08',

                box: SVGFrame.box8,
                countryOfTier: [
                    { img: ListCountry.IR, name: 'IR Iran', minted: 9 },
                    { img: ListCountry.SaudiArabia, name: 'Saudi Arabia', minted: 9 },
                    { img: ListCountry.Australia, name: 'Australia', minted: 9 },
                    { img: ListCountry.CostaRica, name: 'Costa Rica', minted: 9 },
                ]
            },
        ]
        return (
            <>
                <div className="flex sm:flex-row  flex-col  sm:justify-start items-center gap-[2rem] w-auto">
                    <div onClick={this.previous} className="cursor-pointer sm:block hidden">
                        {SVGFrame.prevTire}
                    </div>
                    <div className="w-[45rem]  sm:w-[45rem]   ">
                        <Slider className="flex justify-between" ref={c => (this.slider = c)} {...settings}>
                            {listTire.map((item, index) => (<div key={index} className="">
                                <TireCard box={item.box} minted={item.minted} mintedRatio={item.mintedRatio} countryOfTier={item.countryOfTier} />
                            </div>))}
                        </Slider>
                    </div>
                    <div onClick={this.next} className="cursor-pointer sm:block hidden">
                        {SVGFrame.nextTire}
                    </div>
                    <div className="flex justify-center gap-x-[4rem] sm:hidden">
                        <div onClick={this.previous} className="cursor-pointer">
                            {SVGFrame.prevTire}
                        </div>
                        <div onClick={this.next} className="cursor-pointer">
                            {SVGFrame.nextTire}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}